import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data/ServicesData';
import SpotlightCard from './reactbits/SpotlightCard/SpotlightCard';

const CheckIcon = () => (
  <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 6.5L1.5 4.5L0.5 5.5L3.5 8.5L8.5 3.5L7.5 2.5L3.5 6.5Z" fill="#c79528" />
  </svg>
);

// COMPONENT

const ServicesMain = () => {
  return (
    <div className="home3-solution-section sec-mar">
      <div className="container">
        <div className="row justify-content-center g-4">
          {services.map((service) => (
            <div
              key={service.id}
              className="col-lg-4 col-md-6 col-sm-10 wow animate fadeInUp"
              data-wow-delay={service.delay}
              data-wow-duration="1500ms"
            >
              <SpotlightCard className="solution-card magnetic-item nalexus-spotlight" spotlightColor="rgba(223, 169, 37, 0.35)">
                <div className="icon">{service.iconSVG}</div>
                <div className="solution-content">
                  <h4>
                    <Link to={service.link}>{service.title}</Link>
                  </h4>
                  <p>{service.description}</p>
                  <ul className="solution-feature">
                    {service.features.map((feature, index) => (
                      <li key={index}>
                        <CheckIcon /> {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </SpotlightCard>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesMain;





